import script from "/app/components/basic_button.vue?type=script";
import { render } from "/app/components/basic_button.vue?type=template";
script.render = render;
export default script;
